const DropdownSingleSelector = ({
  dimensionIndex,
  questionIndex,
  defaultAnswer,
  options,
  handleChange,
}) => {
  const renderOption = (option, optionIndex) => {
    return (
      <option
        key={`survey-question-field-dropdown-${dimensionIndex}_${questionIndex}-option-${optionIndex}`}
        value={option}
      >
        {option}
      </option>
    );
  };

  return (
    <select className="custom-select" value={defaultAnswer ?? ""} onChange={handleChange}>
      <option value="">Seleccione una opción</option>
      {options.map((option, optionIndex) => renderOption(option, optionIndex))}
    </select>
  );
};

export default DropdownSingleSelector;
